import React from 'react';
import { connect } from 'react-redux';

import 'css/ui/Header.css';
import logo from 'imgs/logo.svg';

import Link from 'ui/Link';
import { changeThemeHue } from 'ducks/ui';

import {
	HOME_SCREEN,
	PROJECTS_SCREEN,
	POSTS_SCREEN
} from 'routes';



const Header = ({ changeThemeHue }) => {

	return (
		<header className="app-header">
			<nav>
				<Link
					to={HOME_SCREEN}
					nav
					exact
					customStyle
					className="app-header__home-link"
				>
					<img
						onClick={changeThemeHue}
						src={logo}
						width="60"
						height="60"
						alt="logo"
						className="app-header__logo"
					/>
					<span className="app-header__name">Caleb Miller</span>
				</Link>

				<Link
					to={POSTS_SCREEN}
					nav
					customStyle
					className="app-header__nav-link"
				>
					Blog
				</Link>

				<Link
					to={PROJECTS_SCREEN}
					nav
					customStyle
					className="app-header__nav-link"
				>
					Projects
				</Link>
			</nav>
		</header>
	);
};



const mapDispatchToProps = { changeThemeHue };

export default connect(null, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/ui/Header.jsx